<mat-dialog-content class="rounded-0">
    <div class="d-flex justify-content-between">
        <h5 class="fw-semibold">{{data.title}}</h5>
        <img class="ms-3 avs-modal-close-btn mb-1" width="30" src="assets/icons/x.svg" alt="close-modal-icon"
            (click)="onCloseModalClicked()">
    </div>
    <span> {{ data.message }}</span>
    <div class="d-flex justify-content-between mt-5 border-top pt-3">
        <button *ngIf="data.confirmButtonText" class="btn btn-sm btn-outline-danger rounded-0"
            (click)="onConfirmButtonClicked()">
            {{data.confirmButtonText}}
        </button>
        <button *ngIf="data.cancelButtonText" class="btn btn-sm btn-outline-danger  rounded-0"
            (click)="onCancelButtonClicked()">
            {{data.cancelButtonText}}
        </button>
    </div>
</mat-dialog-content>